export const isValidJSON = (json) => {
  try {
    var obj = JSON.parse(json);
    if (obj && typeof obj === 'object' && obj !== null) {
      return true;
    }
  } catch (err) {}
  return false;
};
